module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2a"
  }, [_c('a', {
    attrs: {
      "id": "page_xvi"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Acknowledgments")])])]), _c('a', {
    attrs: {
      "id": "page_xvi"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("T")]), _vm._v("he author is grateful to the following people for permission to use their photographs:")]), _vm._v(" "), _c('p', {
    staticClass: "left1"
  }, [_vm._v("Kiaran Allen")]), _vm._v(" "), _c('p', {
    staticClass: "lefta"
  }, [_vm._v("Ron Rink")]), _vm._v(" "), _c('p', {
    staticClass: "lefta"
  }, [_vm._v("Fiona Smith")]), _vm._v(" "), _c('p', {
    staticClass: "lefta"
  }, [_vm._v("Skip Dolega")]), _vm._v(" "), _c('p', {
    staticClass: "lefta"
  }, [_vm._v("Dave and Eileen Hughes")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c3eb5aa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/10_Acknowledgments.vue
// module id = 84
// module chunks = 0